const GameCurrencyReducers = (state = false, action) => {
  switch (action.type) {
    case "storeGameCurrency":
      return action.payload;
    default:
      return state;
  }
};

export default GameCurrencyReducers;
